import { Routes } from '@angular/router';
import { canActivateRoute } from './auth';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
  {
    path: '',
    loadComponent: async () => import('@app/layout').then((m: any) => m.DefaultLayoutComponent),
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },
      {
        path: 'dashboard',
        loadComponent: async () => import('@app/pages').then((m: any) => m.DashboardComponent),
        canActivate: [canActivateRoute],
      },
      {
        path: 'perfil',
        loadComponent: async () => import('@app/pages/perfil').then((m) => m.PerfilComponent),
        canActivate: [canActivateRoute],
      },
    ],
  },
  {
    path: 'signin',
    loadComponent: async () => import('@app/auth').then((m: any) => m.SigninComponent),
  },
  {
    path: 'signup',
    loadComponent: async () => import('@app/auth').then((m: any) => m.SignupComponent),
  },
  {
    path: 'forgot',
    loadComponent: async () => import('@app/auth').then((m: any) => m.ForgotComponent),
  },
  {
    path: 'magic-link',
    loadComponent: async () => import('@app/auth').then((m: any) => m.MagicLinkComponent),
  },
  {
    path: 'otp',
    loadComponent: async () => import('@app/auth').then((m: any) => m.OtpComponent),
  },
  {
    path: 'whatsapp',
    loadComponent: async () => import('@app/auth').then((m: any) => m.WhatsappLoginComponent),
  },
  {
    path: 'reset',
    loadComponent: async () => import('@app/auth').then((m: any) => m.ResetComponent),
  },
  {
    path: 'confirm',
    loadComponent: async () => import('@app/auth').then((m: any) => m.ConfirmComponent),
  },
  {
    path: 'termos',
    loadComponent: async () => import('@app/legal').then((m: any) => m.LegalPageComponent),
    data: { document: 'terms' },
  },
  {
    path: 'privacidade',
    loadComponent: async () => import('@app/legal').then((m: any) => m.LegalPageComponent),
    data: { document: 'privacy' },
  },
  {
    path: 'error',
    loadComponent: async () => import('@app/error').then((m: any) => m.ErrorComponent),
  },
  {
    path: '**',
    redirectTo: 'error',
    pathMatch: 'full',
  },
];
